import { apiInstance } from '@shared/api'

export const getUserFavorites = async () => {
  const res = await apiInstance.get<FavoritesResponse>('/api/v1/user/favorites')
  return res.data
}

export const postUserFavorites = async (body: ToggleFavoriteRequest) => {
  const res = await apiInstance.post<ApiResponse>('/api/v1/user/favorites', body)
  return res.data
}

export const getUserPnlDaily = async (params: DailyPnlParams) => {
  const res = await apiInstance.get<DailyPnlResponse>('/api/v1/user/pnl/daily', { params })
  return res.data
}
